import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Features from '../components/Features';
import Insights from '../components/Insights';
import FAQ from '../components/FAQ';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';

const Home: React.FC = () => {
    return (
        <>
            <Hero />

            <FadeInSection delay={0.1}>
                <About />
            </FadeInSection>

            <FadeInSection delay={0.15}>
                <Features />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <Insights />
            </FadeInSection>

            <FadeInSection delay={0.15}>
                <FAQ />
            </FadeInSection>

            <FadeInSection delay={0.1}>
                <CallToAction />
            </FadeInSection>

            <Footer />
        </>
    );
};

export default Home;
